/**
 * Whether a hike copied via "Edit a Copy" (window.sourceHikeData) has a
 * canonical route worth locking to by default — an official HiiKER hike, or
 * someone else's shared/public plan. Copying your OWN public hike doesn't
 * count (you already own the source, free-edit is the expected default).
 */
export function isCanonicalHikeSource(
  hikeData: { made_official_at?: string | null; publicly_visible?: boolean; user_id?: number } | null | undefined,
  currentUserId: number | string | undefined,
): boolean {
  if (!hikeData) return false;
  if (hikeData.made_official_at != null) return true;
  return Boolean(hikeData.publicly_visible) && hikeData.user_id !== currentUserId;
}
